import React, {useEffect, useState} from 'react';
import * as util from "../../utils/util";
import api from "../../utils/api";
import {Box, Grid, Typography} from "@mui/material";
import Top from "../Top";
import Bottom from "../Bottom";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import {useLocation} from "react-router-dom";
import RadialChart from '../../components/RadialChart';
import LineChart from '../../components/LineChart';

const initMonthInfo = {
  RECORD_COUNT: 0,  // 기록 일수
  RECORD_PERCENT: 0,  // 기록 일수
  COMPLETE_PERCENT: 0,  // 목표 달성률
  COMPLETE_COUNT: 0,  // 목표 달성 일수
  // TARGET_AVG: 0,  // 평균 목표 값
  VALUE_AVG: 0,  // 평균 값
}

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const WeightMonthHistory = () => {
  const [monthInfo, setMonthInfo] = React.useState(initMonthInfo);
  const [monthValue, setMonthValue] = useState(new Date().getMonth() + 1);
  const [monthSeries, setMonthSeries] = React.useState([ {curve: 'linear', data: [0]} ]);
  const [xAxis, setXAxis] = React.useState( [{ data: [0] }] );
  const [title, setTitle] = React.useState('');
  const [unit, setUnit] = React.useState('');
  const { state } = useLocation();
  const { type } = state ?? {};

  useEffect(() => {
    setMonthData();
  }, [monthValue]);

  function setMonthData() {
    if (util.strNull(window.localStorage.userCusID) !== '') {
      const date = new Date();
      const month = date.getFullYear() + '-' + (('00' + monthValue.toString()).slice(-2));
      api.get(`app/api/v1/AP_002_013?type=${type}&month=${month}`).then(res => {
        setMonthInfo(res.data.result_data.info);
      }).catch(function (error) {
        console.log(error)
      });

      params.token = localStorage.getItem('token') || '';
      params.from = date.getFullYear() + (('00' + monthValue.toString()).slice(-2)) + '01';
      params.to = date.getFullYear() + (('00' + monthValue.toString()).slice(-2)) + '31';
      params.target = util.getDateByCustom('yyyyMMdd', 0);

      let apiUrl = 'app/api/v1/AP_002_018'; setTitle('체중'); setUnit('kg');

      api.get(`${apiUrl}?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
        if (res.data.result_code === '0') {
          let tempArr = [];
            for (let item of res.data.result_data.data.weight_v2) {
              let obj = { weight: 0, month: '' };
              obj.month = item.date;
              obj.weight = item.weight;
              tempArr.push(obj);
            }
            
            setMonthSeries([
              {
                curve: "linear",
                data: tempArr.map((v :any) => v.weight),
              },
            ]);
            setXAxis([
              {
                data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
              },
            ]);
        }
      }).catch(function (error) {
        console.log(error)
      });
    }
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title={'월간 '+title+' 기록'} />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', }}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setMonthValue((prev) => prev - 1)} sx={{ 'display': monthValue > 1 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
            {new Date().getFullYear() + '년 ' + monthValue + '월'}
            <ArrowRightIcon onClick={() => setMonthValue((prev) => prev + 1)} sx={{ 'display': monthValue < new Date().getMonth() + 1 && monthValue > 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Box sx={{
              '& .radial-gauge svg': { width: '220px', height: '160px' },
              mb:2
            }}>
              <RadialChart value={monthInfo.VALUE_AVG} />
            </Box>

            <Box sx={{ mb: 2 }}>
              {
                monthInfo.RECORD_COUNT > 0 ? (
                  monthInfo.RECORD_PERCENT === 100 ? (
                    <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                      <Typography sx={{ fontSize: 14, color: '#ef8322', fontWeight: 700 }}>체중 기록을 잘 하고 있어요</Typography>
                    </Stack>
                  ) : (
                    <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                      <Typography sx={{ fontSize: 14, color: '#555', fontWeight: 700 }}>체중 기록이 완벽히 되지 않았어요</Typography>
                    </Stack>
                  ) 
                ) : (
                  <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                    <Typography sx={{ fontSize: 14, color: '#777', fontWeight: 700 }}>아직 기록이 없어요</Typography>
                  </Stack>
                )
              }
            </Box>

            <Stack direction={'row'} justifyContent={'space-evenly'} alignItems={'center'} sx={{ width: '100%', mb: 1 }}>
              <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} >
                <Typography sx={{ fontSize: 14, color: '#555', }}>일일 평균 체중</Typography>
                <Typography component="div" sx={{ fontSize: 20, color: '#777', fontWeight: 700 }}>
                  {monthInfo.VALUE_AVG}
                  <Typography component="span" sx={{ fontSize: 14, color: '#777', ml: 1, }}>{unit}</Typography>
                </Typography>
              </Stack>
              <Divider orientation="vertical" variant="middle" flexItem />
              <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                <Typography sx={{ fontSize: 14, color: '#555', }}>측정 완료일</Typography>
                <Typography component="div" sx={{ fontSize: 20, color: '#777', fontWeight: 700 }}>
                  {util.formatComma(monthInfo.RECORD_COUNT)}
                  <Typography component="span" sx={{ fontSize: 14, color: '#777', ml: 1, }}>일</Typography>
                </Typography>
              </Stack>
            </Stack>

          </Stack>


          <Box sx={{ bgcolor: '#fff', p: '10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>월간현황</Typography>
              </Stack>
            </Stack>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <Typography component="div" sx={{ fontSize: 12, color: '#555', mr: .5, }}>이번 달의
                <Typography component="span" sx={{ fontSize: 14, color: '#0069ce', fontWeight: 700, mb: 2, }}> 체중 </Typography>
                기록이에요.
              </Typography>
            </Box>
            <Divider />

            <Box sx={{ mt: -3.5, '& .MuiChartsAxis-tickContainer:last-child' : {display:'none'} }}>
              <LineChart series={monthSeries} xAxis={xAxis} isReferenceLine={true}  />
            </Box>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}



export default WeightMonthHistory;